import { cva } from "./index.ts";

export const card = cva({
  base: "flex flex-col gap-5 bg-white p-6 rounded-lg",
});
